import { createSlice } from "@reduxjs/toolkit";
import { AlertLevel } from "../../models/AlertLevel";

interface ExceptionSlice {
  message: string | null;
  show: boolean;
  level: AlertLevel | null;
}

const initialState: ExceptionSlice = {
  message: null,
  show: false,
  level: null,
};

const errorSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setInformation: (state, action) => {
      state.message = action.payload;
      state.show = true;
      state.level = AlertLevel.information;
    },
    setWarning: (state, action) => {
      state.message = action.payload;
      state.show = true;
      state.level = AlertLevel.warning;
    },
    setError: (state, action) => {
      state.message = action.payload;
      state.show = true;
      state.level = AlertLevel.error;
    },
    setSuccess: (state, action) => {
      state.message = action.payload;
      state.show = true;
      state.level = AlertLevel.success;
    },
    clearAlert: (state) => {
      state.message = null;
      state.show = false;
      state.level = null;
    },
  },
});

export const { setInformation, setWarning, setError, clearAlert, setSuccess } = errorSlice.actions;
export default errorSlice.reducer;
